import React, { useState } from 'react';
import { Drawer } from 'vaul';
import '../styling/ItProjectsLayoutMobile.css'; 

const projects = [
  {
    title: "Networking",
    description: [
      "Performed GPON network configuration , diagnostics & automated configuration using Python scripts",
      "Installed and configured MiniFTTO systems to ensure efficient data transmission.",
      "Diagnosed and resolved camera-related issues, including network connectivity and image quality problems.",
      "Assigned static IP addresses to CCTV cameras for improved system organization and control.",
      "Configured and maintained IVS and NVR devices to support reliable CCTV operations.",
    ],
    location: "Jadriya Mall\n(Baghdad)",
    image: "",
    year: "Oct 2024 - Jan 2025",
    progress: 100,
  },
  {
    title: "Parking Management",
    description: [
      "Led the installation of a parking management system with controllers and over 700 sensors to automate vehicle entry and exit.",
      "Configured the integration of sensors with software for real-time parking management.",
      "Set up guiding screens to help users navigate available parking spaces, including a large outdoor display.",
      "Set up ticket machine software and diagnosed both hardware and software issues",
    ],
    location: "Jadriya Mall\n(Baghdad)",
    image: "",
    year: "Nov 2024 - Jan 2025",
    progress: 100,
  },
  {
    title: "Nurse Call System",
    description: [
      "Led the installation of a nurse call system with isolators and over 100 devices (call points, pull cords, over-door lights) to ensure efficient patient-to-staff communication.",
      "Configured integration of nurse call devices with central monitoring software for real-time call management.",
      "Set up display panels and over-door indicator lights to help staff quickly locate patients requiring assistance.",
      "Conducted thorough testing to ensure all components operated smoothly and reliably.",
    ],

    location: "Ibn Sina Hospital\n(Green zone)",
    image: "",
    year: "April 2025 – May 2025",
    progress: 100,
  },
  {
    title: "Networking",
    description: [
      "Deployed and set up a fiber-optic network with managed network switches (VLANs).",
      "Configured a Safeeye PBX telephony system with over 200 IP phones",
      "Automated IP phones configuration using Python scripts with Selenium and ChromeDriver.",
    ],

    location: "Ibn Sina Hospital\n(Green zone)",
    image: "",
    year: "April 2025 – Present",
    progress: 80,
  },
];

export default function ItProjectsLayoutMobile({closeTips}) {
  const [selectedProject, setSelectedProject] = useState(null);
  const [open, setOpen] = useState(false);

  const openDrawerWithProject = (project) => {
    setSelectedProject(project);
    setOpen(true);
  };

  return (
    <div style={{ padding: '2rem', backgroundColor: '#0f172a', minHeight: '100vh' }}>
      <div style={{marginTop:"62px"}}>
        {projects.map((project, index) => (
      <div
       key={index}
          onClick={() => {
            closeTips();
  openDrawerWithProject(project);
}}  
      style={{
        backgroundColor: '#1f2937',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '20px',
        color: 'white',
        boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
      }}
    >
     
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
         <h3 style={{ fontSize: '20px', margin: '0 0 6px' }}>{project.title}</h3>
        
        <span style={{ fontSize: '12px', color: '#9ca3af' }}>{project.year}</span>
      </div>
     <span style={{ backgroundColor: '#10b981', borderRadius: '6px', padding: '2px 8px', fontSize: '12px', fontWeight: 'bold' }}>
          {project.location}
        </span>
      {/*<p style={{ fontSize: '14px', color: '#d1d5db' }}>{project.description}</p>*/}
    </div>
          
      ))}
      </div>
      

      <Drawer.Root open={open} onOpenChange={setOpen}>
        <Drawer.Portal>
          <Drawer.Overlay className="drawer-overlay" />
          <Drawer.Content className="drawer-content">
            <div className="drawer-body">
              <div className="drawer-inner">
                <div aria-hidden className="drawer-handle" />
                {selectedProject && (
                  <>
                    <Drawer.Title className="drawer-title">{selectedProject.title}</Drawer.Title>
                    <p className="drawer-text" style={{ marginBottom: '10px', color: '#9ca3af' }}>
                      {selectedProject.location} — {selectedProject.year}
                    </p>
                    <p className="drawer-text">
                       <ul
              style={{
                paddingLeft: "1rem",
                lineHeight: "1.8",
                fontSize: "16px",
              }}
            >
              {selectedProject.description.map((line, index) => (
                <li
                  key={index}
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <span style={{ color: "red", marginRight: "10px" }}>✔</span>
                  <span>{line}</span>
                </li>
              ))}
            </ul>
                    </p>
                  </>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
